import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_384hnspyq8: FaireBrandEntity = {
  token: "b_384hnspyq8",
  type: "brand",
  name: "macaron centrale",
  avatarUrl:
    "https://cdn.faire.com/fastly/02a479482aac80697ed13d3ea31fb2cbf272443e6fd2b44d8e877c188fcd9215.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/772131dfda2bfb8af58defc97a3658656897aa5dce6b1af8683e5e8415301237.png",
  logoUrl:
    "https://cdn.faire.com/fastly/02a479482aac80697ed13d3ea31fb2cbf272443e6fd2b44d8e877c188fcd9215.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/772131dfda2bfb8af58defc97a3658656897aa5dce6b1af8683e5e8415301237.png",
  location: "sunnyvale, CA, USA",
  minimumOrderDollars: 0,
  rating: 4.5,
  reviewCount: 43,
  isInsider: true,
  description:
    "At Macaron Centrale, we transform tradition into exceptional confections. Founded in 2020, our mission is to craft French macarons that are both artful and unforgettable. Every macaron is made fresh to order using high-quality ingredients, precision, and creativity.\n\nWith over 200 rotating flavors in classic and vegan varieties, we offer one of the widest selections available. Our signature Mini!s—bite-size French macarons—are customer favorites for cafés, gift boxes, dessert assortments, and upscale retail displays. Whether you’re restocking or sourcing for events, we focus on consistent quality, refined presentation, and delicious results in every batch.\n\nShipping Practice:\nMacarons are made to order and shipped ambient (room temperature) for the best texture and flavor. You may freeze them once upon arrival or serve immediately. A cold pack is included to help reduce heat exposure during transit. We are not responsible for packages mishandled after delivery or reported outside a 48-hour window. For advance scheduling, please message us.\n\nPriority Lead Time for Insider Buyers:\nRetailers who order through our Faire Direct link receive priority production and a faster 1–2 day lead time (standard is 5–7 days before shipping).\nDirect Link: https://macaroncentrale.faire.com",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:51:36.885Z",
    importedBy: "entity-db-cli",
  },
};
